import React, { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';
import ErrorMessage from '../ErrorMessage';
import schema from '../../EditForm/schema';
import { InputGroup, Input, UItils, Icon } from '@nearst/ui';

import styles from '../Fields.module.scss';

const Text = forwardRef(function Text(props, ref) {
	const { name, required = false, icon, error, ...rest } = props;
	const {
		register,
		formState: { errors }
	} = useFormContext();

	const capitalized = name[0].toUpperCase() + name.slice(1);

	const inputContent = icon ? (
		<div className={`${styles.inputWithIcon} ${styles.fullWidthInput}`}>
			<Icon className={styles.inputIcon}>{icon}</Icon>
			<Input
				id={name}
				className={UItils.classnames(`${errors?.[name] ? styles.invalid : ''} ${styles.iconInput}`)}
				containerClassName={styles.fullWidthInput}
				{...register(name, { required: required ? 'Required' : '', validate: schema[name] })}
				{...rest}
				ref={ref}
			/>
		</div>
	) : (
		<Input
			id={name}
			className={UItils.classnames(`${errors?.[name] ? styles.invalid : ''}`)}
			containerClassName={styles.fullWidthInput}
			{...register(name, { required: required ? 'Required' : '', validate: schema[name] })}
			{...rest}
			ref={ref}
		/>
	);

	return (
		<InputGroup label={capitalized} htmlFor={name} requiredField={required}>
			<>
				{inputContent}
				<ErrorMessage name={name} error={error} />
			</>
		</InputGroup>
	);
});

export default Text;
